import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/border.css'
import '@/assets/css/reset.css'
import { initRemSize } from './utils/common'
import store from './store'
import vConsole from 'vconsole'

// const vc = new vConsole({ theme: 'dark' })

Vue.config.productionTip = false

Vue.use(ElementUI);

initRemSize()

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
